import { Component, Inject, Input, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { clientPayout, payoutDetatilsModel } from '../../models/client-payout'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'
import { payoutDetatilsSpPopUp } from '../../models/sp-payout.models'

@Component({
	selector: 'app-payout-details',
	templateUrl: './payout-details.component.html',
	styleUrls: ['./payout-details.component.scss'],
})
export class PayoutDetailsComponent implements OnInit {
	payoutSpDetails!: payoutDetatilsSpPopUp
	payoutClientDetails!: clientPayout
	imgPath = environment.attachmentPath
	constructor(
		public dialog: MatDialogRef<PayoutDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: payoutDetatilsModel,
		public translate: TranslateService
	) {
		if (data.serviceProvider) {
			this.payoutSpDetails = data.serviceProviderData
		} else if (data.client) {
			this.payoutClientDetails = data.clientData
		}
	}

	ngOnInit(): void {}

	closeDialog() {
		this.dialog.close()
	}
}
